import React from 'react'

import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { IpadHeaderButtons } from '../../components/CommonComponents'
import RedCarpetLogo from '../../components/UI/RedCarpetLogo'

import { HeaderWrapper } from '../../style/CommonComponents'
import {
  getFluidSize,
  getFluidSizeWithFullFormula as gF,
  palette,
  pxToRem,
} from '../../style/theme'
import { useDispatch, useSelector } from 'react-redux'
import afaActions from '../../store/afa/actions'
import { customerSelector } from '../../store/customer/selectors'
import { useGetAfaCartQuery } from '../../services/afaCart'
import { CheckAdjustButton } from './CheckAdjustButton'

const Wrapper = styled(HeaderWrapper)`
  position: relative;
  padding: ${getFluidSize(`${pxToRem(15)}rem`, 15)} 2vw;
  height: auto;
`
export const ButtonHeader = styled.button`
  text-transform: capitalize;
  color: ${palette.tangaroa};
  font-size: ${gF('px', 12, 24, 1366, 3840)};
  padding-left: ${pxToRem(16)}rem;
  padding-right: ${pxToRem(16)}rem;

  &.disabled {
    color: ${palette.santasGray};
    pointer-events: none;
  }

  &::before {
    content: '';
    display: inline-block;
    height: 0.8em;
    width: 0.8em;
    background-size: 0.8em 0.8em;
    background-repeat: no-repeat;
    margin-right: 0.5em;
  }

  &.duplicate::before {
    background-image: url("data:image/svg+xml,%3Csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M7.392 0h5.562c.381 0 .711 0 .984.022.288.024.578.076.858.218.415.212.752.55.964.964.142.28.194.57.218.858.022.272.022.603.022.984v5.562c0 .381 0 .712-.022.984a2.244 2.244 0 0 1-.218.858 2.206 2.206 0 0 1-.964.964c-.28.142-.57.194-.858.218-.273.022-.603.022-.984.022h-1.3v1.3c0 .381 0 .711-.022.984a2.245 2.245 0 0 1-.218.858 2.206 2.206 0 0 1-.964.964c-.28.142-.57.194-.858.218C9.32 16 8.99 16 8.608 16H3.046c-.38 0-.712 0-.984-.022a2.243 2.243 0 0 1-.858-.218 2.206 2.206 0 0 1-.964-.964 2.245 2.245 0 0 1-.218-.858C0 13.665 0 13.335 0 12.954V7.392c0-.381 0-.712.022-.985.024-.288.076-.577.218-.857.212-.415.55-.752.964-.964.28-.142.57-.195.858-.218.272-.022.603-.022.984-.022h1.3v-1.3c0-.38 0-.712.022-.984.023-.289.076-.578.218-.858.212-.415.549-.752.964-.964.28-.142.57-.194.857-.218C6.68 0 7.011 0 7.393 0zM3.075 5.86c-.418 0-.686 0-.89.017-.195.016-.263.043-.293.058a.691.691 0 0 0-.302.303c-.016.03-.042.098-.058.293-.017.203-.018.471-.018.89v5.504c0 .418.001.686.018.89.016.195.042.263.058.293a.69.69 0 0 0 .302.302c.03.016.098.043.293.058.204.017.472.018.89.018h5.504c.419 0 .687-.001.89-.018.195-.015.263-.042.293-.058a.691.691 0 0 0 .303-.302c.015-.03.042-.098.058-.293.016-.204.017-.472.017-.89V7.421c0-.419 0-.687-.017-.89-.016-.195-.043-.263-.058-.293a.692.692 0 0 0-.303-.303c-.03-.015-.098-.042-.293-.058a12.295 12.295 0 0 0-.89-.017H3.075zm8.58 4.28V7.392c0-.381 0-.712-.023-.985a2.245 2.245 0 0 0-.218-.857 2.206 2.206 0 0 0-.964-.964 2.245 2.245 0 0 0-.858-.218 12.972 12.972 0 0 0-.984-.022H5.86V3.075c0-.418 0-.686.017-.89.016-.195.043-.263.058-.293a.691.691 0 0 1 .303-.302c.03-.016.098-.042.293-.058.203-.017.471-.018.89-.018h5.504c.418 0 .686.001.89.018.195.016.263.042.293.058a.69.69 0 0 1 .302.302c.016.03.043.098.058.293.017.204.018.472.018.89v5.504c0 .419-.001.687-.018.89-.015.195-.042.263-.058.293a.691.691 0 0 1-.302.303c-.03.015-.098.042-.293.058-.204.016-.472.017-.89.017h-1.27z' fill='%23031434'/%3E%3C/svg%3E");
  }

  &.check-adjust::before {
    background-image: url("data:image/svg+xml,%3Csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M13.653 12.918c-1.565 1.39-3.61 2.067-5.657 2.067-1.564 0-3.15-.41-4.493-1.23l.16 1.461c.04.392-.28.748-.722.784h-.08c-.4 0-.762-.285-.802-.641l-.341-3.207v-.142c.02-.09.04-.178.1-.268.12-.196.361-.338.622-.374l3.61-.303c.442-.035.843.25.883.642.04.392-.28.748-.722.784l-1.725.142c2.467 1.461 5.857 1.23 8.044-.712 1.685-1.497 2.287-3.688 1.584-5.7-.14-.375.1-.785.522-.891.421-.125.882.089 1.003.463.882 2.53.12 5.255-1.986 7.125zM1.898 9.765c-.722-2.03-.1-4.204 1.585-5.7 2.186-1.942 5.556-2.174 8.044-.713L9.8 3.495c-.44.035-.762.391-.722.783.04.375.381.642.803.642h.08l3.61-.303c.382-.036.682-.303.723-.624v-.142L13.954.644c-.04-.392-.442-.677-.883-.641-.441.036-.762.392-.722.784l.16 1.46C9.38.325 5.108.592 2.34 3.05.233 4.92-.529 7.645.374 10.175c.1.302.421.498.762.498.08 0 .16-.017.24-.035.422-.107.663-.499.522-.873z' fill='%23031434'/%3E%3C/svg%3E");
  }

  &.loading::before {
    -webkit-animation: rotate 1.5s linear infinite;
    animation: rotate 1.5s linear infinite;
  }

  &.share::before {
    background-image: url("data:image/svg+xml,%3Csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M6.315 2.536a.444.444 0 1 1-.631-.627L7.46.13a.445.445 0 0 1 .631 0L9.87 1.91a.445.445 0 0 1-.631.627L8.22 1.518v8.705a.444.444 0 0 1-.889 0V1.518L6.315 2.536zM11.332 16h-7.11A2.221 2.221 0 0 1 2 13.778V6.224a2.221 2.221 0 0 1 2.222-2.222h1.555a.444.444 0 0 1 0 .889H4.222a1.333 1.333 0 0 0-1.333 1.333v7.554a1.333 1.333 0 0 0 1.333 1.333h7.11a1.333 1.333 0 0 0 1.333-1.333V6.224a1.333 1.333 0 0 0-1.333-1.333H9.777a.444.444 0 0 1 0-.89h1.555a2.222 2.222 0 0 1 2.222 2.223v7.554A2.222 2.222 0 0 1 11.332 16z' fill='%23031434'/%3E%3C/svg%3E%0A");
  }

  @keyframes rotate {
    to {
      transform: rotate(360deg);
    }
  }
`

export const AfaCartHeader: React.FC = () => {
  const { t } = useTranslation()

  const customer = useSelector(customerSelector)
  const doorsLength = customer.doors.length

  const getCartQuery = useGetAfaCartQuery()
  const cartQuantity = (getCartQuery.data?.items || []).reduce((result, item) => {
    result += item.unconfirmedQuantity
    return result
  }, 0)

  const dispatch = useDispatch()

  return (
    <Wrapper>
      <RedCarpetLogo />

      {cartQuantity > 0 && (
        <IpadHeaderButtons>
          {doorsLength > 1 && (
            <ButtonHeader
              className="duplicate"
              onClick={() => {
                dispatch(afaActions.toggleDuplicateCartOnDoorModalOpen())
              }}
            >
              {t('Afa.duplicate')}
            </ButtonHeader>
          )}

          <CheckAdjustButton className="check-adjust" />

          <ButtonHeader
            className="share"
            onClick={() => {
              dispatch(afaActions.toggleShareCartOnDoorModalOpen())
            }}
          >
            {t('Afa.share')}
          </ButtonHeader>
        </IpadHeaderButtons>
      )}
    </Wrapper>
  )
}

export default AfaCartHeader
